import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PrevArrow.css';

/**
 * Prev Arrow - Custom Arrow for the Slider Component.
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class PrevArrow extends Component {

    /**
     * Prop types
     *
     * @type {{style: *, onClick: *}}
     */
    static propsTypes = {
        style: PropTypes.object,
        onClick: PropTypes.func.isRequired
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {style, onClick} = this.props;

        return <div className="nc-icon nc-tail-left CustomArrowPrev"
                    style={style}
                    onClick={onClick}/>
    }
}



// WEBPACK FOOTER //
// ./src/components/global/slider/prevArrow/PrevArrow.jsx